document.addEventListener(
  "DOMContentLoaded",
  function handleDOMContentLoaded() {
    if (typeof Swiper === "undefined") {
      return;
    }

    var sliderContainers = document.querySelectorAll(
      ".p-research-slider__swiper"
    );
    if (!sliderContainers || sliderContainers.length === 0) {
      return;
    }

    var swiperInstances = new Map();

    function initMobile() {
      sliderContainers.forEach(function (container) {
        if (swiperInstances.has(container)) {
          return;
        }
        /* eslint-disable no-new */
        var instance = new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 16,
          pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
          },
          // navigation: {
          //   nextEl: container.querySelector(".swiper-button-next"),
          //   prevEl: container.querySelector(".swiper-button-prev"),
          // },
          keyboard: { enabled: true },
          a11y: { enabled: true },
        });
        swiperInstances.set(container, instance);
      });
    }

    function destroyAll() {
      swiperInstances.forEach(function (instance) {
        if (instance && typeof instance.destroy === "function") {
          instance.destroy(true, true);
        }
      });
      swiperInstances.clear();
    }

    function handleBreakpoint(e) {
      var isMobile = e.matches; // max-width: 768px
      if (isMobile) {
        initMobile();
      } else {
        destroyAll();
      }
    }

    var mq = window.matchMedia("(max-width: 768px)");
    handleBreakpoint(mq);
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", handleBreakpoint);
    } else if (typeof mq.addListener === "function") {
      mq.addListener(handleBreakpoint);
    }
  }
);
